import axios from 'axios'

const axiosIns = axios.create({
  baseURL:'https://identitytoolkit.googleapis.com/v1'
})

export default axiosIns